var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pins-for-user"},[_c('PHeader'),_c('UserProfileCard',{attrs:{"in-pins":true,"username":_vm.filters.userFilter}}),_c('Pins',{attrs:{"pin-filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }